/**
 * Tema (claro/escuro/auto seguindo o SO).
 *
 * Persistido em localStorage. Aplica classe `dark` no <html> quando
 * resolvido como dark. Listener pra mudanca do system theme quando
 * preferencia e 'auto'.
 */

const KEY = 'filmaker.theme';

export type Tema = 'light' | 'dark' | 'auto';

export function getTema(): Tema {
  const stored = localStorage.getItem(KEY);
  if (stored === 'light' || stored === 'dark' || stored === 'auto') return stored;
  return 'auto';
}

export function setTema(t: Tema): void {
  localStorage.setItem(KEY, t);
  aplicarTema();
}

export function temaResolvido(): 'light' | 'dark' {
  const t = getTema();
  if (t === 'auto') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return t;
}

export function aplicarTema(): void {
  const r = temaResolvido();
  if (r === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

/**
 * Iniciar listeners — chamado no main.tsx no boot.
 */
export function iniciarTema(): void {
  aplicarTema();
  // Quando preferencia for auto, segue o SO em tempo real
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (getTema() === 'auto') aplicarTema();
  });
}
